import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { OrganizationConfig } from "@idw-types/data/organization-config";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { injectAxnCompanyId } from "@utils/parameter-injector";

type UpdateAxnCompanyRequestResponse = {
    transferObject: OrganizationConfig;
};

export const updateAxnCompanyRequest = async (
    organizationConfig: OrganizationConfig
): Promise<GenericNetworkResponse<UpdateAxnCompanyRequestResponse>> => {
    const route = injectAxnCompanyId(
        apiRoutes.axnadminCore.data.axncompanyWithId,
        organizationConfig.id
    );

    const { id, name, companyCode, type, customerSupportTierUID, status } = organizationConfig
    const body = {
        id,
        name,
        companyCode,
        type,
        customerSupportTierUID,
        status
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};
